























import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import Likes from "../../../../../share/common/Likes.vue";
import {Element} from "@api/models/Element";
import { Rating } from "@api/models/Rating";

@Component({
    components: { Likes }
})
export default class SessionCounters extends Vue {
    @Prop({ required: true }) sessionId: string;
    @Prop({ default: 0 }) commentsCount: number;
    @Prop() likes: Rating | undefined

    get likesCount() {
        return this.likes?.count || 0;
    }

    get liked() {
        return !!this.likes?.rating;
    }

    @Watch('likes', { deep: false })
    watchSession() {
        (this.$refs.likes as Likes | undefined)?.onAmountChange();
    }

}
